import React from 'react';
import { Query } from 'react-apollo';
import Timeline, { Note } from '../../../../components/Timeline';
import { Card, CardSegment } from '../../../../components/ui';
import ErrorScreen from '../../../../components/utils/ErrorScreen';
import { NotesQuery, NotesQueryVariables } from '../../../../queries/__generated__/NotesQuery';
import { notesQuery } from '../../../../queries/notes';
import EmptyState from './EmptyState';

interface GroupFeedProps {
  group: {
    id: string;
    subjects: {
      id: string;
      name: string;
      slug: string;
    }[];
    trackers: {
      id: string;
      name: string;
      slug: string;
      type: TrackerType;
      subjects: {
        id: string;
        name: string;
        slug: string;
      }[];
    }[];
  };
  notebookId: string;
  setActiveTab: (value: 'SETTINGS') => void;
}

const GroupFeed: React.FC<GroupFeedProps> = ({ group, notebookId, setActiveTab }) => {
  return (
    <Query<NotesQuery, NotesQueryVariables>
      query={notesQuery}
      variables={{
        input: {
          notebookId,
          subjectIds: group.subjects.map(s => s.id),
          first: 20
        }
      }}
    >
      {({ data, error, loading }) => {
        if (loading) {
          return <div />;
        }
        if (error) {
          return <ErrorScreen error={error.message} />;
        }

        let notes: Note[] = [];

        if (data!.notes.edges) {
          notes = data!.notes.edges.map(e => e!.node!);
        }

        return (
          <>
            {notes.length > 0 && <Timeline notes={notes} />}

            {notes.length < 1 && <EmptyState setActiveTab={setActiveTab} />}
          </>
        );
      }}
    </Query>
  );
};

export default GroupFeed;
